
import useMediaQuery from '@mui/material/useMediaQuery'
import { useFleetId } from 'features/settings'
import { FleetNotFound } from 'frame/components'
import { Box, Grid } from '@mui/material'
import List from './list'
import DocumentPanel from './document-panel'
import { useMeasure } from 'utils'

const ListWrapper = (props) => {
  const fleetId = useFleetId()
  const mobileView = useMediaQuery('(max-width: 600px)')

  const [ref, { width: documentPanelWidth }] = useMeasure()
  if ( ! fleetId) {
    return (
      <FleetNotFound title={props.config.title} />
    )
  }

  const documentListProps = {
    ...props,
    sx: props.config.title === 'Documents' ? {
      maxHeight: `${Math.round(window.innerHeight - 240)}px`,
      overflowY: 'auto',
      marginBottom: '0px',
      marginTop: '24px',
    } : {},
  }

  const isSupportPDFPreview = navigator.mimeTypes && navigator.mimeTypes['application/pdf'] && navigator.mimeTypes['application/pdf'].enabledPlugin

  return (
    <Box component={mobileView ? 'div' : Grid} container>
      <Box component={mobileView ? 'div' : Grid} item md={props.documentPreviewUri ? 4 : 12} sm={12}>
        <List {...documentListProps} fleetId={fleetId} driverAssignmentColumnHeaderInjection={props.driverAssignmentColumnHeaderInjection}/>
      </Box>
      {isSupportPDFPreview && props.documentPreviewUri && (
        <Box component={mobileView ? 'div' : Grid} item md={8} sm={12} style={{ background: '#FFF' }} ref={ref}>
          <Box
            sx={{
              marginTop: '12px',
              marginLeft: '20px',
              marginRight: '20px',
              padding: 0,
              '@media (max-width:600px)': {
                right: 0,
                position: 'static',
                paddingTop: 2,
                paddingRight: 2,
                paddingLeft: 2,
                paddingBottom: 2,
              },
            }}>
            <DocumentPanel
              fileUri={props.documentPreviewUri}
              height={Math.round(window.innerHeight - 133)}
              width={Math.round(documentPanelWidth - 40)}/>
          </Box>
        </Box>
      )}
    </Box>
  )
}

export default ListWrapper
